import o from"./_copyObject.js";import r from"./keysIn.js";function t(t,e){return t&&o(e,r(e),t)}export{t as default};
//# sourceMappingURL=_baseAssignIn.js.map
